module.exports = __webpack_public_path__ + "images/apple-touch-icon-152x152.68ca46014f03c4ab2664da53c515db62.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/apple-touch-icon-152x152.png
// module id = 991
// module chunks = 0